import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LocaleService } from './locale.service';
import { AuthService } from './auth.service';
import { CollectiveDataProvider } from '../_providers/collective-data-provider';


@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private localeService: LocaleService,
    private auth: AuthService,
    private collectiveDataProvider: CollectiveDataProvider
  ) {}

  trackPageViews() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.sendEvent('page_view', event.urlAfterRedirects, {});
    });
  }

  trackCustomEvent(eventName: string, data: any = {}) {
    let url = this.router.url;
    this.sendEvent(eventName, url, data);
  }

  private sendEvent(eventType: string, url: string, data: any) {
    // El colectivo puede tener desactivado el registro de actividad: en ese caso
    // no se llama al endpoint, que respondería sin guardar nada.
    if (!this.collectiveDataProvider.getTrackActivity()) {
      return;
    }

    const serviceUrl = `${environment.apiUrl}/${environment.apiVersion}/activity/store?l=${this.localeService.getLocale()}`;
    const payload = {
      '_event': eventType,
      '_api_key': environment.apiKey,
      '_user': this.auth.getUser() ? this.auth.getUser().username : null,
      '_route': url,
      '_data': data
    };
    this.http.post(serviceUrl, payload)
      .subscribe({
        next: () => console.log(`Event ${eventType} sent successfully`),
        error: (err) => console.error(`Error sending event: ${err}`)
    });
  }
}
